"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Note_1 = __importDefault(require("@features/ItemCommon/components/ModerationNote/Note"));
var react_i18next_1 = require("react-i18next");
var CreateNote_1 = __importDefault(require("@features/ItemCommon/components/ModerationNote/CreateNote"));
var moderationNotes_1 = require("@features/ItemCommon/service/moderationNotes");
function NotePanel(props) {
    var domain = props.domain, documentId = props.documentId, updateModerationNotes = props.updateModerationNotes, angularJsDependencies = props.angularJsDependencies, data = props.data, job = props.job;
    var t = (0, react_i18next_1.useTranslation)().t;
    if (!data)
        return null;
    return (react_1.default.createElement("div", { className: "moderation-notes" },
        react_1.default.createElement("div", { className: "moderation-notes__create-note__container" },
            react_1.default.createElement(CreateNote_1.default, { job: job, domain: domain, documentId: documentId, updateModerationNotes: updateModerationNotes })),
        react_1.default.createElement("div", null,
            !data.notes && data.loading && react_1.default.createElement("div", { className: "moderation-notes__text" }, t('ITEM.MODERATION_NOTES.LOADING_TEXT')),
            !data.notes && !data.loading && data.failedToLoad && (react_1.default.createElement("div", { className: "moderation-notes__text" },
                t('ITEM.MODERATION_NOTES.FAILED_TO_LOAD_TEXT'),
                react_1.default.createElement("i", { className: "moderation-notes__text-container__refresh-icon implioicons-re-do", onClick: function () {
                        return job.ad &&
                            (0, moderationNotes_1.fetchModerationNotes)(domain, job.ad).then(function (notes) {
                                if (notes) {
                                    updateModerationNotes(notes);
                                }
                            });
                    } })))),
        react_1.default.createElement("div", { "data-cy": "moderation-note-list" }, data.notes &&
            !data.failedToLoad &&
            !data.loading &&
            data.notes.map(function (note) { return (react_1.default.createElement(Note_1.default, { job: job, key: note.id, note: note, angularJsDependencies: angularJsDependencies, domain: domain, updateModerationNotes: updateModerationNotes })); }))));
}
exports.default = NotePanel;
